// uses ./appsList.less
import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';
import AppsListFilters from './appsListFilters/AppsListFilters';
import AppsListItems from './appsListItems/AppsListItems';
import MobileFilters from './appsListFilters/mobileFilters/MobileFilters';
import { replaceFilter, toggleFilters, resetFilters } from './appsListFilters/appsListFiltersActionCreators';
import { withRouter } from '../../withRouter';

const AppsList = ({
    filters,
    search,
    expanded,
    apps,
    isFetching,
    children,
    hasFiltersSet,
    platformSetToProtect,
    dispatchToggleFilters,
    dispatchResetFilters,
}) => (
    <div className="appsList" id="appsList">
        <MobileFilters dispatchToggleFilters={dispatchToggleFilters} dispatchResetFilters={dispatchResetFilters} />
        <AppsListFilters filters={filters} search={search} expanded={expanded} />
        <AppsListItems
            apps={apps}
            isFetching={isFetching}
            shouldDisplaySections={!hasFiltersSet && !platformSetToProtect}
        />
        {children}
    </div>
);

AppsList.propTypes = {
    apps: PropTypes.array.isRequired,
    isFetching: PropTypes.bool.isRequired,
    filters: PropTypes.object.isRequired,
    user: PropTypes.object,
    search: PropTypes.string.isRequired,
    expanded: PropTypes.bool.isRequired,
    children: PropTypes.node,
    shouldUpdate: PropTypes.bool,
    hasFiltersSet: PropTypes.bool.isRequired,
    platformSetToProtect: PropTypes.bool.isRequired,
    dispatchToggleFilters: PropTypes.func,
    dispatchResetFilters: PropTypes.func,
    dispatchReplaceFilter: PropTypes.func,
};

const mapStateToProps = (state) => {
    const { search } = state.appsList;
    const { filters } = state.appsList;

    const hasFiltersSet =
        search ||
        Object.keys(filters)
            .filter((filterName) => filterName !== 'platform')
            .map((filterName) =>
                Object.keys(filters[filterName]).some(
                    (filterOptionName) => filters[filterName][filterOptionName] === true
                )
            )
            .some((isSet) => isSet);
    const platformSetToProtect = filters.platform.protect && !filters.platform.connect;

    return { ...state.appsList, user: state.user, hasFiltersSet: !!hasFiltersSet, platformSetToProtect };
};

const mapDispatchToProps = {
    dispatchToggleFilters: toggleFilters,
    dispatchResetFilters: resetFilters,
    dispatchReplaceFilter: replaceFilter,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppsList));
